import { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import loadScript from 'load-script';

// Vendored replacement for react-ckeditor-component@1.1.0 (codeslayer1/react-ckeditor).
// The upstream package is unmaintained and uses APIs that React 19 removes:
//   - componentWillReceiveProps (replaced here with componentDidUpdate)
//   - findDOMNode (replaced here with a createRef on the host div)
// External behavior is unchanged: same props, same events.dispatch, same DOM
// shape (one <div className={activeClass}/> for CKEDITOR.appendTo).
//
// Full CKEditor 4 -> 5 migration is parked as Prompt 4.5b. See docs/react-19-upgrade-plan.md.
class CKEditor4 extends Component {
  constructor(props) {
    super(props);
    this.state = { isScriptLoaded: props.isScriptLoaded };
    this.hostRef = createRef();
    this.unmounting = false;
  }

  componentDidMount() {
    if (!this.state.isScriptLoaded) {
      loadScript(this.props.scriptUrl, this.onLoad);
    } else {
      this.onLoad();
    }
  }

  componentDidUpdate(prevProps) {
    const editor = this.editorInstance;
    if (editor && this.props.content !== prevProps.content && editor.getData() !== this.props.content) {
      editor.setData(this.props.content);
    }
  }

  componentWillUnmount() {
    this.unmounting = true;
  }

  onLoad = () => {
    if (this.unmounting) return;

    this.setState({ isScriptLoaded: true });

    if (!window.CKEDITOR) {
      // eslint-disable-next-line no-console
      console.error('CKEditor not found');
      return;
    }

    const host = this.hostRef.current;
    if (!host) return;

    this.editorInstance = window.CKEDITOR.appendTo(host, this.props.config, this.props.content);

    Object.keys(this.props.events).forEach((event) => {
      this.editorInstance.on(event, this.props.events[event]);
    });
  };

  render() {
    return <div ref={this.hostRef} className={this.props.activeClass}/>;
  }
}

CKEditor4.defaultProps = {
  content: '',
  config: {},
  isScriptLoaded: false,
  scriptUrl: 'https://cdn.ckeditor.com/4.6.2/standard/ckeditor.js',
  activeClass: '',
  events: {},
};

CKEditor4.propTypes = {
  content: PropTypes.any,
  config: PropTypes.object,
  isScriptLoaded: PropTypes.bool,
  scriptUrl: PropTypes.string,
  activeClass: PropTypes.string,
  events: PropTypes.object,
};

export default CKEditor4;
